import React, { useState } from 'react';
import {
    Typography, Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Snackbar,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    InputAdornment,
    Avatar
} from '@mui/material';
import { useMain } from '../hooks/useMain';

import TableCells from 'src/components/Tables/TableCells';




export const TrimData = (data) => {
    if (data?.length < 25)
        return data;
    return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};


const Users = ({ data, setData }) => {


    const { deleteOwner ,setShowMessage} = useMain();

    const handleUpdate=()=>{

    }

    const handleDetails=()=>{

    }



    const handleDeleteField =async (id) => {
        try {
          const res=await deleteOwner(id)
            if (res?.statusCode === 200) {
              setData(data?.filter((data) => data?._id !== id));
              setShowMessage({message:'Salon Owner deleted successfully',messageType:'success'});
            } else {
              setShowMessage({message:res?.message || 'Error ouccures in delete Salon Owner',messageType:'error'});
            }
        } catch (error) {
          setShowMessage({message:error?.message || 'Error ouccures in delete Salon Owner',messageType:'error'});
          
        }
      };
 

    return (
        <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>

            <table className="table-container">
        <thead className="table-thead">
          <tr>
            {/* <th style={{ width: '30%' }}>
              <CheckboxInputs
                type={'Heading'}
                isAllChecked={isAllChecked}
                handleAllCheckboxChange={handleAllCheckboxChange}
              />
            </th> */}
            {['Name','Email','Phone', 'Date','Actions'].map(
              (h,index) => {
                return <th key={index} style={{ width: '100%' }}>{h}</th>;
              },
            )}
          </tr>
        </thead>
        <tbody className="table-tbody">
          {data.map((item) => {
            return (
              <tr key={item._id}>
                {/* <td style={{ width: '30%' }}>
                  <CheckboxInputs
                    type={'content'}
                    handleSignleCheckboxChange={handleSignleCheckboxChange}
                    checkedItems={checkedClients}
                    fieldId={item?._id}
                  />
                </td> */}
                <td style={{ width: '100%' }}>{TrimData(item?.name)}</td>
                <td style={{ width: '100%' }}>{TrimData(item?.email)}</td>
                <td style={{ width: '100%' }}>{item?.phone}</td>
                <td style={{ width: '100%' }}>{new Date(item?.createdAt)?.toDateString()}</td>
                <td style={{ width: '100%' }}>
                  <TableCells
                    type="button"
                    handleDeleteField={handleDeleteField}
                    handleUpdate={() => handleUpdate(item)}
                    handleDetails={handleDetails}
                    field={item?._id}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

        </Box >
    );
};

export default Users;